
export { createErrorLink } from "/opt/atlassian/pipelines/agent/build/packages/modules/module-core/src/modules/api/index.ts"